export const disciplinesRecord = [
     {
        disciplineId: 1,
        disciplineName: "Skilled Nursing"
    },
    {
        disciplineId: 2,
        disciplineName: "Physical Therapy"
    },
    {
        disciplineId: 3,
        disciplineName: "Occupational Therapy"
    },
    {
        disciplineId: 4,
        disciplineName: "Speech Therapy"
    },
    {
        disciplineId: 5,
        disciplineName: "Medical Social Worker"
    },
    {
        disciplineId: 6,
        disciplineName: "Home Health Aide"
    },
    {
        disciplineId: 8,
        disciplineName: "Nurse to open"
      },
]